import axios from 'axios';
import Rest from './rest';

export default class Call extends Rest {
  static path = 'call';

  static answer(callId) {
    return axios.post(`/api/call/${callId}/answer`);
  }

  static transfer(callId, userId) {
    return axios.post(`/api/call/${callId}/transfer/${userId}`);
  }

  static claim(id) {
    return axios.post(`/api/call/${id}/claim`);
  }
}
